<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-3">
              Aqui você pode gerenciar as informações dos benefícios de
              aceleração cadastrados no portal. Para tal, preencha as
              informações abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-9 col-lg-12">
          <div class="card shadow mb-3">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                <i class="fas fa-building mr-2"></i>
                Editar parceria
                <base-button
                  size="sm"
                  type="danger"
                  class="float-right"
                  @click="handleOpenModalRemove()"
                >
                  <i class="fas fa-trash mr-1"></i> Deletar parceria
                </base-button>
              </h3>
            </div>
            <div class="card-body vld-parent" ref="partner_container">
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
              </div>
              <div class="row ml-lg-2">
                <div class="col-12">
                  <base-input label="Status da parceria">
                    <br />
                    <base-radio
                      name="public"
                      class="mb-3"
                      v-model="model.status"
                      :inline="true"
                    >
                      Visível
                    </base-radio>
                    <base-radio
                      name="hidden"
                      class="mb-3"
                      v-model="model.status"
                      :inline="true"
                    >
                      Oculto
                    </base-radio>
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <base-input
                    label="Nome da parceria"
                    v-model.trim="model.name"
                    placeholder="Digite o nome"
                  />
                </div>
                <div class="col-lg-6">
                  <base-input
                    label="Categoria"
                    v-model.trim="model.category"
                    placeholder="Qual a categoria do benefício?"
                  />
                </div>
              </div>
              <hr class="my-4" />
              <div class="row ml-1">
                <h6 class="heading-small text-muted mb-4">
                  Informações complementares (opcional)
                </h6>
              </div>
              <div class="row ml-lg-2">
                <div class="col-lg-12">
                  <label class="form-control-label">Link externo</label>
                  <base-input
                    placeholder="Digite o link"
                    addon-left-icon="fas fa-external-link-alt"
                    v-model.trim="model.link"
                  >
                  </base-input>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label"> Benefícios </label>
                  <div class="np-container-edditable">
                    <quill-editor
                      v-model="model.benefit"
                      :options="editorEdittable"
                    >
                    </quill-editor>
                  </div>
                </div>
                <div class="col-lg-6">
                  <label class="form-control-label"> Instruções </label>
                  <div class="np-container-edditable">
                    <quill-editor
                      v-model="model.benefit"
                      :options="editorEdittable"
                    >
                    </quill-editor>
                  </div>
                </div>
              </div>
              <div class="row ml-2">
                <div class="col-lg-12">
                  <hr class="my-4" />
                  <label class="form-control-label d-block"
                    >Imagem de destaque
                    <i
                      class="fas fa-info-circle ml-1"
                      title="
                        'A imagem deve possuir tamanho máximo de 2MB e, preferencialmente, ser do formato <b>PNG</b> ou <b>JPG</b> com dimensão de <b>500x500 pixels</b>.'
                      "
                    />
                  </label>
                  <p v-if="image_url" class="description">
                    <i class="fas fa-info-circle mr-2"></i> Você já fez upload
                    de uma imagem, porém, se desejar, você pode substituir a
                    <base-button
                      type="link"
                      @click="openLink(image_url)"
                      title="'Abrir imagem'"
                      class="p-0 mt--1"
                    >
                      imagem atual
                      <i class="fas fa-link ml-1"></i>
                    </base-button>
                  </p>
                  <file-select
                    v-model="image"
                    title="Selecione a imagem"
                    accept="image/*"
                    :mbSize="2"
                    type="warning"
                  ></file-select>
                </div>
              </div>
              <div class="row mt-4" v-if="error">
                <div class="col-12 text-center">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
              </div>
              <div class="row mt-4 text-right">
                <div class="col-12">
                  <span
                    :title="
                      isValidModel
                        ? 'Clique para salvar'
                        : 'Preencha todas as informações obrigatórias antes de continuar'
                    "
                  >
                    <base-button
                      type="primary"
                      @click="handleUpdate()"
                      :disabled="!isValidModel"
                      :custom="true"
                    >
                      Atualizar informações
                    </base-button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalRemove.show"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir a
            <span class="text-danger">parceria</span>?
          </h4>
          <p class="mt-3 mb-0">
            Ao confirmar, a parceria "{{ model.name }}" será removida do portal.
          </p>
        </div>
        <div class="col-12 text-center" v-if="modalRemove.error">
          <base-alert type="danger"
            >Ocorreu um erro ao remover a parceria. Tente novamente.</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modalRemove.show = false"
        >
          Voltar
        </base-button>
        <base-button type="white text-danger" @click="handleRemove()">
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      model: {
        status: "public",
        name: "",
        category: "",
        benefit: "",
        instructions: "",
        link: "",
      },
      image: null,
      image_url: null,
      requiredFields: ["name", "category", "status"],
      modalRemove: {
        show: false,
        error: "",
      },
      error: "",
      editorEdittable: {
        placeholder:
          "Escreva aqui... (lembre-se, se necessário, você pode linkar arquivos pelo editor)",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.partner_container,
      width: 90,
      height: 90,
    });
    try {
      const { data } = await api.get(`/adm/partners/${this.$route.params.id}`);
      this.image_url = data.image_url;
      delete data.image_url;
      delete data.image_key;
      Object.assign(this.model, data);
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      this.$router.push("/admin/beneficios-aceleradas");
    } finally {
      loader.hide();
    }
  },
  methods: {
    async handleUpdate() {
      this.error = "";
      const loader = this.$loading.show({
        container: this.$refs.partner_container,
        width: 90,
        height: 90,
      });
      try {
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        const formData = new FormData();
        if (this.image) {
          formData.append("image", this.image, this.image.name);
        }
        formData.append("model", JSON.stringify(this.model));
        await api.put(`/adm/partners/${this.model.id}`, formData, config);
        this.$toasted.show("Informações atualizadas com sucesso");
        this.$router.push("/admin/beneficios-aceleradas");
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao atualizar a parceria");
        this.error =
          "Ocorreu um erro ao atualizar a parceria. Por favor, verifique os campos e tente novamente.";
      } finally {
        loader.hide();
      }
    },
    handleOpenModalRemove() {
      this.modalRemove.error = "";
      this.modalRemove.show = true;
    },
    async handleRemove() {
      this.modalRemove.error = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/adm/partners/${this.model.id}`);
        this.$toasted.show("Parceria removida com sucesso");
        this.$router.push("/admin/beneficios-aceleradas");
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao remover a parceria");
        this.modalRemove.error = true;
      } finally {
        loader.hide();
      }
    },
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
  },
  computed: {
    isValidModel() {
      const data = this.model;
      for (const key of this.requiredFields) {
        if (!data[key]) return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.card-profile-image img {
  width: 180px;
  height: 180px;
  border-radius: 10%;
}
</style>
<style>
p > strong {
  font-weight: bold !important;
}
.np-container-edditable .quill-editor .ql-container,
.np-container-edditable .quill-editor .ql-container .ql-editor {
  height: 6rem;
  width: 100%;
}
</style>
